// Power Reviews: Enhance zero-review + no-brand-score scenario with prominent CTA
(function() {
  function createStarRating() {
    const starsContainer = document.createElement('div');
    starsContainer.className = 'slb-pr-enhancement-stars';
    
    for (let i = 0; i < 5; i++) {
      const star = document.createElement('span');
      star.className = 'slb-pr-enhancement-star';
      star.innerHTML = '☆'; // Empty star
      starsContainer.appendChild(star);
    }
    
    return starsContainer;
  }

  function enhanceNoReviewsScenario() {
    try {
      // Check if this is scenario 3: No reviews AND no brand score
      const reviewSnapshot = document.querySelector('[data-testid="review-snapshot"]');
      const brandScoreBlock = document.querySelector('.pr-review-snapshot-block-brandscore');
      
      // Check if there are actual reviews by looking at rating count
      const snippetRatingCount = document.querySelector('.pr-snippet-rating-count');
      const hasReviews = snippetRatingCount && snippetRatingCount.textContent !== 'No Ratings';
      
      // Only enhance if: has review snapshot AND no brand score AND no reviews
      if (!reviewSnapshot || brandScoreBlock || hasReviews) return;
      
      const snippetSection = document.querySelector('.pr-review-snapshot-block-snippet');
      
      // Find the original write review link (we'll trigger it on button click)
      const originalWriteReviewLink = document.querySelector('.pr-snippet-write-review-link');
      if (!originalWriteReviewLink) return;
      
      // Check if we've already enhanced this (don't duplicate)
      if (document.querySelector('.slb-pr-enhancement-wrapper')) return;
      
      // Create the enhancement wrapper with completely custom classes
      const enhancementWrapper = document.createElement('div');
      enhancementWrapper.className = 'slb-pr-enhancement-wrapper';
      enhancementWrapper.innerHTML = `
        <div class="slb-pr-enhancement-header">
          <div class="slb-pr-enhancement-header-intro">
            <h2 class="slb-pr-enhancement-title">Customer Reviews</h2>
            <p class="slb-pr-enhancement-byline">
              <span>by </span>
              <a href="http://www.powerreviews.com" target="_blank" rel="noopener noreferrer" class="slb-pr-enhancement-link">PowerReviews</a>
            </p>
          </div>
        </div>
      `;
      
      // Create stars
      const starsDiv = createStarRating();
      enhancementWrapper.appendChild(starsDiv);
      
      // Create button that will trigger the original Power Reviews link
      const ctaButton = document.createElement('button');
      ctaButton.className = 'slb-pr-enhancement-button';
      ctaButton.textContent = 'Write the First Review';
      ctaButton.addEventListener('click', function(e) {
        e.preventDefault();
        // Trigger click on the original hidden Power Reviews link to open modal
        originalWriteReviewLink.click();
      });
      
      enhancementWrapper.appendChild(ctaButton);
      
      // Hide the original snippet section and insert our enhancement
      if (snippetSection && snippetSection.parentNode) {
        snippetSection.style.display = 'none';
        snippetSection.parentNode.insertBefore(enhancementWrapper, snippetSection);
      } else if (reviewSnapshot && reviewSnapshot.parentNode) {
        reviewSnapshot.parentNode.insertBefore(enhancementWrapper, reviewSnapshot.nextSibling);
      }
      
      // Also hide the pr-rd-no-reviews section if it exists
      const noReviewsSection = document.querySelector('.pr-rd-no-reviews');
      if (noReviewsSection && noReviewsSection.parentNode) {
        noReviewsSection.parentNode.style.display = 'none';
      }
    } catch (error) {
      console.error('Power Reviews enhancement error:', error);
    }
  }

  // Watch for PR initialization
  try {
    const observer = new MutationObserver(() => {
      const reviewSnippet = document.querySelector('#pr-reviewsnippet[data-pr-mounted="true"]');
      if (reviewSnippet) {
        enhanceNoReviewsScenario();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  } catch (error) {
    console.error('Power Reviews observer initialization error:', error);
  }
})();